import type { BoxProps } from 'theme-ui';
import { Flex } from 'theme-ui';

import { useMediaQuery } from '../../helpers/mediaQuery';

export const Wrapper = ({ sx, ...rest }: BoxProps) => {
  const isScreenSm = useMediaQuery({ maxWidth: 'sm' });

  return (
    <Flex
      paddingBottom={isScreenSm ? 'grid-32' : 'grid-44'}
      paddingTop={isScreenSm ? 'grid-24' : 'grid-32'}
      paddingX={isScreenSm ? 'grid-24' : 'grid-40'}
      sx={{
        alignItems: isScreenSm ? undefined : 'center',
        height: 'calc(100% - 3rem)',
        justifyContent: 'center',
        minHeight: '200px',
        ...sx,
      }}
      {...rest}
    />
  );
};
